import CryptoJS from 'crypto-js';
import { User } from '../store.js';

const apiProductionURL = window.location.hostname == "localhost"
? 'http://airbetter.local'
: 'https://rest.airbetter.com';

const fetchNodeProduction = async (node, params = {}, method="POST") => {
	try{

		const url = new URL(apiProductionURL + node);
		let user;
		const unUser = User.subscribe(v => user = v);

		const headers = getAuthHeaders(user,params, method);
		const res = await fetch(url,headers);
		return res.json();
	} catch (ex){
		console.log({ex})
	}
}

const getAuthHeaders = (user, query, method="POST") => {
	if(user && user.accessToken &&  user.id){
		return {
			headers:{
				accessToken: user.accessToken,
			},
			method:method,
			body: method=="POST" ? query:null
		};
	} else {
		return {
			method:method,
			body: method=="POST" ? query:null
		};
	}
}

export default fetchNodeProduction;